import { createContext, useContext } from "react";
import type { TreeID, UndoManager } from "loro-crdt";
import type { CursorEphemeralStore } from "loro-prosemirror";
import { TextSelection } from "prosemirror-state";
import type { EditorView } from "prosemirror-view";

/** Something the page can move the keyboard focus into: a block's editor in whatever mode it shows. */
export interface FocusTarget {
  focusEdge(edge?: "start" | "end"): void;
}

export function pmFocusTarget(v: EditorView): FocusTarget {
  return {
    focusEdge(edge) {
      v.focus();
      const pos = edge === "end" ? v.state.doc.content.size - 1 : 1;
      v.dispatch(v.state.tr.setSelection(TextSelection.near(v.state.doc.resolve(Math.max(0, Math.min(pos, v.state.doc.content.size))))));
    },
  };
}

export interface PageEditorContextValue {
  undoManager: UndoManager;
  cursors: CursorEphemeralStore;
  registerView(treeId: TreeID, target: FocusTarget): void;
  unregisterView(treeId: TreeID): void;
  focusBlock(treeId: TreeID, edge?: "start" | "end"): void;
}

export const PageEditorContext = createContext<PageEditorContextValue | null>(null);

export function usePageEditorContext(): PageEditorContextValue {
  const v = useContext(PageEditorContext);
  if (!v) throw new Error("PageEditorContext missing");
  return v;
}
